import type React from "react";

interface DiplopiaToolProps {
	enabled: boolean;
	offset?: { x: number; y: number };
	overlap?: number;
	onChange: (params: {
		enabled: boolean;
		offset?: { x: number; y: number };
		overlap?: number;
	}) => void;
}

export const DiplopiaTool: React.FC<DiplopiaToolProps> = ({
	enabled,
	offset = { x: 0, y: 0 },
	overlap = 0,
	onChange,
}) => {
	return (
		<div className="p-4">
			<div className="mb-2 font-semibold">Diplopia Check</div>
			<div className="mb-2">
				<span className="mr-2">Enable Second Image?</span>
				<button
					className={`px-2 py-1 rounded-l ${enabled ? "bg-blue-500 text-white" : "bg-gray-200"}`}
					onClick={() => onChange({ enabled: true, offset, overlap })}
				>
					Yes
				</button>
				<button
					className={`px-2 py-1 rounded-r ${!enabled ? "bg-blue-500 text-white" : "bg-gray-200"}`}
					onClick={() => onChange({ enabled: false })}
				>
					No
				</button>
			</div>
			{enabled && (
				<>
					<div className="mb-2">
						<label className="block text-xs mb-1">Offset X: {offset.x}</label>
						<input
							type="range"
							min={-100}
							max={100}
							value={offset.x}
							onChange={(e) =>
								onChange({
									enabled,
									offset: { ...offset, x: Number(e.target.value) },
									overlap,
								})
							}
						/>
					</div>
					<div className="mb-2">
						<label className="block text-xs mb-1">Offset Y: {offset.y}</label>
						<input
							type="range"
							min={-100}
							max={100}
							value={offset.y}
							onChange={(e) =>
								onChange({
									enabled,
									offset: { ...offset, y: Number(e.target.value) },
									overlap,
								})
							}
						/>
					</div>
					<div>
						<label className="block text-xs mb-1">Overlap: {overlap}</label>
						<input
							type="range"
							min={0}
							max={100}
							value={overlap}
							onChange={(e) =>
								onChange({ enabled, offset, overlap: Number(e.target.value) })
							}
						/>
					</div>
				</>
			)}
		</div>
	);
};
